const selectors = {
  blogHeaderContainer: '#blog-filter-controls',
  blogDrawerInner: '#blog-filters-drawer-inner',
  blogDrawerContainer: '#blog-filters-drawer',
  openFilters: '#blog-filter-toggle',
  closeFilters: 'button[aria-close]',
  gridToggle: 'fostr-class-toggle-button',
  filterOverlay: 'blog-filter__overlay'
};

class BlogFilters {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.blogHeaderContainer);
    const drawer = document.querySelector(selectors.blogDrawerContainer);
    return container ? {
      container,
      drawer,
      blogDrawerInner: document.querySelector(selectors.blogDrawerInner),
      openFilters: container.querySelector(selectors.openFilters),
      closeFilters: drawer.querySelectorAll(selectors.closeFilters),
      gridToggle: container.querySelectorAll(selectors.gridToggle)
    } : {};
  }

  _setupEventListeners() {
    this.elements.openFilters.addEventListener('click', this._handleOpenButtonClick);
    this.elements.closeFilters.forEach((element) => {
      element.addEventListener('click', this._handleCloseButtonClick);
    });
    this.elements.gridToggle.forEach((element) => {
      element.addEventListener('click', this._handleGridButtonClick);
    });
    document.addEventListener('click', (evt) => {
      if (evt.target.classList.contains(selectors.filterOverlay)) this._handleFocusOut(evt.target.id);
    })
  }

  _handleOpenButtonClick = ({ currentTarget }) => {
    const drawer_container = currentTarget.getAttribute('aria-controls');
    document.querySelector(`#${drawer_container}`).classList.remove('hidden');
    setTimeout(() => {
      this.elements.blogDrawerInner.classList.add('open');
    }, 100);
  }

  _handleCloseButtonClick = ({ currentTarget }) => {
    const drawer_container = currentTarget.getAttribute('aria-controls');
    this.elements.blogDrawerInner.classList.remove('open');
    setTimeout(() => {
      document.querySelector(`#${drawer_container}`).classList.add('hidden');
    }, 100);
  }

  _handleGridButtonClick = ({ currentTarget }) => {
    const grid_cols = currentTarget.getAttribute('data-toggle-class');
    if (grid_cols == 'one-column') document.querySelector(`#article-grid`).classList.remove('two-column');
    else if (grid_cols == 'two-column') document.querySelector(`#article-grid`).classList.add('two-column');
  }

  _handleFocusOut = ( element_id ) => {
    this.elements.blogDrawerInner.classList.remove('open');
    setTimeout(() => {
      document.querySelector(`#${element_id}`).classList.add('hidden');
    }, 100);
  }
}
